import { GA_MEASUREMENT_ID } from '../config/analytics';
import { getConsent } from './cookieConsent';

const SCRIPT_ID = 'esganga-google-analytics';
const GA_DISABLE_KEY = `ga-disable-${GA_MEASUREMENT_ID}`;

function ensureGoogleTagQueue() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };
}

function buildAnalyticsLocation(pathname) {
    const location = new URL(pathname, window.location.origin);
    const current = new URL(window.location.href);
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach((key) => {
        const value = current.searchParams.get(key);
        if (value) location.searchParams.set(key, value.slice(0, 180));
    });
    return location.toString();
}

function initializeGoogleAnalytics(pathname = window.location.pathname) {
    if (!GA_MEASUREMENT_ID || !getConsent()?.analytics) return false;
    const wasDisabled = window[GA_DISABLE_KEY] === true;
    window[GA_DISABLE_KEY] = false;
    ensureGoogleTagQueue();
    if (!document.getElementById(SCRIPT_ID)) {
        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        });
        window.gtag('set', 'ads_data_redaction', true);
        window.gtag('consent', 'update', {
            analytics_storage: 'granted',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        });
        window.gtag('js', new Date());
        window.gtag('config', GA_MEASUREMENT_ID, {
            allow_google_signals: false,
            allow_ad_personalization_signals: false,
            page_title: document.title,
            page_location: buildAnalyticsLocation(pathname)
        });
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
        document.head.appendChild(script);
    } else {
        window.gtag('consent', 'update', { analytics_storage: 'granted' });
        if (wasDisabled) {
            window.gtag('event', 'page_view', {
                page_title: document.title,
                page_location: buildAnalyticsLocation(pathname)
            });
        }
    }
    return true;
}

// Uso general: cualquier interaccion que valga la pena medir aparte del
// page_view automatico (pedido explicito del usuario: "siempre tenemos que
// tener analitica de todo"). Si no hay consentimiento de analitica,
// initializeGoogleAnalytics nunca ha cargado gtag -- en ese caso esto no
// hace nada, en vez de forzar la carga del script solo para un evento.
function trackEvent(name, params = {}) {
    if (!GA_MEASUREMENT_ID || !getConsent()?.analytics || !window.gtag) return;
    window.gtag('event', name, params);
}

function disableGoogleAnalytics() {
    if (GA_MEASUREMENT_ID) window[GA_DISABLE_KEY] = true;
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: 'denied' });
    document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (!name.startsWith('_ga')) return;
        document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}; SameSite=Lax`;
    });
}

export { GA_DISABLE_KEY, SCRIPT_ID, disableGoogleAnalytics, initializeGoogleAnalytics, trackEvent };
